import dataSchema from './data'
import newDateSchema from './newDate'
import observationSchema from './observation'
import collapse from './collapse'

export default {
  dataSchema,
  observationSchema,
  newDateSchema,
  collapse,
}
